import React, { useEffect, useState } from 'react';
import { useLanguageContext } from '@/hooks/context-hooks';
import Button from '../../../Common/button/Button';

const AssignContactDetails = ({ assigneData, saveAssigne }) => {
  const { language } = useLanguageContext();
  const [showAssigneeContact, setShowAssigneeContact] = useState(false);
  const [assigneContactDetails, setAssigneContactDetails] = useState({});

  useEffect(() => {
    if (assigneData && Object.keys(assigneData).length > 0) {
      setAssigneContactDetails(assigneData);
    }
  }, [assigneData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedState = {
      ...assigneContactDetails,
      [name]: value
    };
    setAssigneContactDetails(updatedState);
    if (saveAssigne) {
      saveAssigne(updatedState);
    }
  };

  return (
    <section className='container my-4'>
      <Button className='ps-0 outline-none fs-7' onClick={() => setShowAssigneeContact(!showAssigneeContact)}>
        <span className='me-2'>{language("label.assign_contact_details")}</span>
        {showAssigneeContact ? (<i className="bi bi-caret-up-fill"></i>) : (<i className="bi bi-caret-down-fill"></i>)}
      </Button>
      {showAssigneeContact && (
        <div className="kg-bg-gray px-3 py-4 rounded-4">
          <div className="row gy-3">
            <div className="col-md-6">
              <label htmlFor="assigneName" className="form-label">{language("label.name")}</label>
              <input
                type="text"
                className="form-control"
                id="assigneName"
                name="assigneeUserName"
                value={assigneContactDetails.assigneeUserName || ""}
                placeholder={language("label.name")}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="assignePhoneNo" className="form-label">{language("label.contact_number")}</label>
              <input
                type="number"
                className="form-control"
                maxLength="10"
                id="assignePhoneNo"
                name="assigneeUserId"
                value={assigneContactDetails.assigneeUserId || ""}
                placeholder={language("label.contact_number")}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="assigneeDesignation" className="form-label">{language("label.designation", "Designation")}</label>
              <input
                type="text"
                className="form-control"
                id="assigneeDesignation"
                name="assigneeDesignation"
                value={assigneContactDetails.assigneeDesignation || ""}
                placeholder={language("label.designation", "Designation")}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="assigneeEmail" className="form-label">{language("label.email", "Email")}</label>
              <input
                type="text"
                className="form-control"
                id="assigneeEmail"
                name="assigneeEmail"
                value={assigneContactDetails.assigneeEmail || ""}
                placeholder={language("label.email", "Email")}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="assigneeWorkingHours" className="form-label">{language("label.working_hours", "Working Hours")}</label>
              <input
                type="text"
                className="form-control"
                id="assigneeWorkingHours"
                name="assigneeWorkingHours"
                value={assigneContactDetails.assigneeWorkingHours || ""}
                placeholder={language("label.working_hours", "Working Hours")}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default AssignContactDetails;
